import React from 'react';
import clsx from 'clsx';
import Button from '../../../_custom/Button/Button';
import MultiSelectSearchDropdown from '../MultiSelectSearchDropdown/MultiSelectSearchDropdown';
import { ExistingDirectorOption } from './coApplicantTypes';
import { MANDATE_APPLICANT_PICKER_LABELS } from '../../DealDrawerConstants';
import { plusPurple } from '../../../../assets/hostedassets';
import styles from '../../ManageDealDrawer.module.scss';

interface ApplicantPickerProps {
    existingDirectors: ExistingDirectorOption[];
    /** managementProfileId of every director currently linked to a card (primary or co-applicant). */
    selectedManagementProfileIds: (string | null)[];
    onSelectionChange: (nextSelectedIds: (string | null)[]) => void;
    onAdd: () => void;
    disabled?: boolean;
}

// "Select Applicants" multi-select + Add (Figma): lists every linkable existing director +
// shows the currently-linked ones as chips; picking/deselecting a director or clicking Add
// spawns/removes the Primary/Co-Applicant cards below (see useManageDealDrawer's
// spawnApplicantCard/clearPrimaryApplicant/removeCoApplicantRow).
export const ApplicantPicker: React.FC<ApplicantPickerProps> = ({
    existingDirectors,
    selectedManagementProfileIds,
    onSelectionChange,
    onAdd,
    disabled,
}) => {
    const options = existingDirectors.map((director) => ({ label: director.name, value: director.managementProfileId }));

    return (
        <div className={styles.ApplicantContactFieldRow}>
            <div className={clsx(styles.InputLabel, styles.InputItemLabel)}>{MANDATE_APPLICANT_PICKER_LABELS.label}</div>
            <div className={styles.ApplicantPickerFieldRow}>
                <div className={styles.FieldFullWidthWrapper}>
                    <MultiSelectSearchDropdown
                        sortSelectedOnTop
                        selectedItemClassName={styles.FieldChip}
                        maxVisibleChips="auto"
                        searchBarStyle={{ padding: '0 0.75rem' }}
                        showSelectAll={false}
                        showFloatingLabel={false}
                        options={options}
                        selectedItems={selectedManagementProfileIds}
                        toggleSelection={onSelectionChange}
                        placeholder={MANDATE_APPLICANT_PICKER_LABELS.placeholder}
                        disabled={disabled}
                    />
                </div>
                {!disabled && (
                    <Button
                        type="button"
                        text={MANDATE_APPLICANT_PICKER_LABELS.add}
                        icon={plusPurple}
                        iconSize="14"
                        onClick={onAdd}
                        fit
                        className={styles.CoApplicantAddButton}
                    />
                )}
            </div>
        </div>
    );
};

export default ApplicantPicker;
